import Geom, { LINE, LINE_DASH, LINE_HOVER } from "./geom";

const MIN_KM = 100; // min vzdalenost pro rozpad cary a prepocet na mercator

/**
 * Cara u geometrie mezi 2 body
 */
export default class Line extends Geom {
	/**
	 * Vytvoreni cary.
	 */
	create(points, options = {}) {
		const geom = this._scene.createGeometry(this._scene.GEOMETRY.POLYLINE, null, points, {
			...LINE,
			...options,
		});

		return this._create(points, geom);
	}

	/**
	 * Nastav nove souradnice cary.
	 */
	set coords(coords) {
		if (this._geom) {
			this._coords = coords;
			this._geom.setCoords(coords);
		}
	}

	/**
	 * Vrat puvodni styl.
	 */
	clearStyle() {
		this.setStyle(LINE);
	}

	/**
	 * Nastav styl carkovane cary.
	 */
	setStyleDash() {
		this.setStyle(LINE_DASH);
	}

	/**
	 * Nastaveni hoveru - pro true cerveny, jinak sedy.
	 */
	setHover(state) {
		this.setStyle(state ? LINE : LINE_HOVER);
	}

	/**
	 * Staticka metoda pro spocitani souradnic mezi dvema body. Pokud je vetsi jak urcita vzdalenost, body se prepocitaji podle mercatoru.
	 */
	static calculateLinePoints(startC: any, endC: any) {
		const dist = Math.round(startC.distance(endC) / 1000); // [km]

		return dist >= MIN_KM ? Mapy.Util.getMercatorPoints(startC, endC) : [startC, endC];
	}
}
